import { IonPage, IonContent, IonInput, IonItem, IonIcon, IonAlert, IonHeader, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import React, { useState, useContext } from 'react';
import { withRouter } from "react-router-dom";
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Auth.css';
import { ServerUrl } from '../../constants';
import { AppContext } from '../../context/appContext';
import { VerifyPassword } from '../../constants';

const AdminSignIn: React.FC = (props: any) => {
  const { dispatch } = useContext(AppContext);
  const [username, setUsername] = useState<string>('');
  const [usernameFocus, setUsernameFocus] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const [passwordMode, setPasswordMode] = useState<boolean>(true);
  const [passwordFocus, setPasswordFocus] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [rememberMe, setRememberMe] = useState<boolean>(false);

  useIonViewDidEnter(() => {
    let loginName = localStorage.getItem("ScoreCardUserLoginName");
    if (loginName) {
      setUsername(loginName);
    }
    else {
      setUsername('');
    }
    setPassword('');
  });

  const onSignIn = ()=> {
    if (username.length === 0 || password.length === 0){
         setErrorMessage('Email and/or Password cannot be empty');
    } else {
      if (!VerifyPassword(password)) {
        setErrorMessage("Password must contain at least one numeric digit and a special character, and has more than 7 characters.")
        return;
      }

      axios.post(`${ServerUrl}/Auth/adminlogin`, {username: username, password: password}).then(res => {
        dispatch({type:'SIGNIN', data: 
          { username: username, 
            email: res.data.email, 
            firstname: res.data.firstname,
            lastname: res.data.lastname,
            token: res.data.token, 
            group: res.data.groupName,
            role: res.data.role,
            isEscWorks: res.data.isEscWorks
          }
        })
        if (rememberMe) {
          localStorage.setItem("ScoreCardUserLoginName", username);    
        } else {
          localStorage.removeItem("ScoreCardUserLoginName");
        }
        props.history.push('/');
      }).catch(() => {
        setErrorMessage('Invalid username or password. Please try again or use the Forgot Password link');
      });
    };
  };

  return(
      <IonPage>
        <Navbar />
        <IonContent fullscreen>
          <IonHeader collapse="condense">
            <IonToolbar>
              <IonTitle size="large">Blank</IonTitle>
            </IonToolbar>
          </IonHeader>
          <div style={{ fontSize: '24px', position:'relative' }}>
            <div style={{ paddingTop: '40px'}}>
            <div className='box'>
              <div style={{margin: 'auto', width: '300px',paddingLeft:'40px' }}>
                <img src="/assets/images/escWorks.png" alt="" style={{ width: '200px', height: '80px' }} />
              </div>
              <div style={{display:'flex', justifyContent:'center'}}>
                <img src="/assets/images/person.png" alt="" style={{ width: '60px', height: '60px', marginTop:'40px'}} />
              </div>
              <div style={{textAlign: 'center', fontWeight: 'bold', fontSize: '28px', display: 'flex', margin:'20px 40px 0px 40px', alignItems: 'center'}}>
                <div style={{flexGrow: '1', backgroundColor: 'gray', height: '2px'}}></div>
                <span style={{flexGrow: '0', margin: '0px 20px'}}>Admin Sign In</span>
                <div style={{flexGrow: '1', backgroundColor: 'gray', height: '2px'}}></div>
              </div>
              <div className={`InputContainer ${usernameFocus ? "InputFocused" : ""}`}>
                  <div style={{paddingLeft: '10px', height: '28px'}}><IonIcon src="/assets/svg/person.svg"></IonIcon></div>
                  <IonItem color="transparent" lines="none">
                    <span style={{fontSize: '24px'}}>
                    <IonInput min='0'  value={username} placeholder="Email" 
                        onIonChange={e => { setUsername(e.detail.value!); setErrorMessage(null) }} onFocus={() => setUsernameFocus(true)} onBlur={() => setUsernameFocus(false)}>
                    </IonInput>
                    </span>
                  </IonItem>
              </div>
              {errorMessage && <div style={{color: 'red', margin:'0px 40px 0px 40px'}}>{errorMessage}</div>}
              <div className={`InputContainer ${passwordFocus ? "InputFocused" : ""}`} style={{display: 'flex'}}>
                  <div style={{paddingLeft: '10px', height: '28px'}}><IonIcon src="/assets/svg/lock-closed.svg"></IonIcon></div>
                  <IonItem color="transparent" lines="none">
                    <span style={{fontSize: '24px'}}>
                    {passwordMode && <IonInput min='0'  type="password" value={password} placeholder="Password"
                      onKeyPress={(e) => {if (e.key === 'Enter') { onSignIn() }}}
                      onIonChange={e => {setPassword(e.detail.value!); setErrorMessage(null) }} onFocus={() => setPasswordFocus(true)} onBlur={() => setPasswordFocus(false)}>
                    </IonInput>}
                    {!passwordMode && <IonInput min='0'  value={password} placeholder="Password"
                      onKeyPress={(e) => {if (e.key === 'Enter') { onSignIn() }}}
                      onIonChange={e => {setPassword(e.detail.value!); setErrorMessage(null) }} onFocus={() => setPasswordFocus(true)} onBlur={() => setPasswordFocus(false)}>
                    </IonInput>}
                    </span>
                  </IonItem>
                  <div style={{paddingLeft: '10px', height: '28px'}} onClick={() => setPasswordMode(!passwordMode)}>
                    {passwordMode && <img src="/assets/images/eye.png" alt="" style={{ width: '30px', height: '30px' }} />}
                    {!passwordMode && <img src="/assets/images/eyeOff.png" alt="" style={{ width: '30px', height: '30px' }} />}
                  </div>
              </div>
              <div className="HelpContainer" style={{justifyContent:'space-between'}}>
                <div style={{display:'flex', alignItems:'center'}}>
                  <input type="checkbox" onChange={(e) => setRememberMe(e.target.checked)} id="saveMe" name="saveMe" style={{width: '26px', height: '26px', marginRight: '10px'}} />
                  <label htmlFor='saveMe'>Remember me</label>
                </div>
                <div>
                  <span onClick={() => props.history.push('/forgetpassword')} style={{cursor:'pointer'}}>Forget password?</span>
                </div>
              </div> 
              <div className='ButtonBox' onClick={onSignIn}>
                  <span>Sign In</span>
              </div>
              {/* <div className="HelpContainer" style={{ justifyContent: 'center' }}>
                <span style={{marginRight: '20px'}}>Not registered?</span>
                <span onClick={() => props.history.push('/signup')} style={{textDecoration:'underline', cursor:'pointer'}}>Create an account</span>
              </div>          */}
            </div>
            </div>
            <img src="/assets/images/Background.jpg" alt="" style={{width: '100%', height: 'auto', position:'absolute', top: '0px', left: '0px', zIndex:'-1'}} />
          </div>
          {/* <IonAlert 
              isOpen={errorMessage.length > 0} 
              onDidDismiss={()=> setErrorMessage('')}
              header={'Error'}
              subHeader={''}
              message={errorMessage}
              buttons={['OK']}
          /> */}
        </IonContent>
      </IonPage>
  );
};

export default withRouter(AdminSignIn);
